import styled from 'styled-components';
import { COLORS } from '@/constants';
import { Button } from '@mui/material';

export const Container = styled.div<{ $isMap?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 13px;
  margin-bottom: ${({ $isMap }) => ($isMap ? '12px' : '16px')};

  @media (max-width: 800px) {
    margin-bottom: 10px;
    gap: 10px;
  }
`;

export const HeadBox = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 1280px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    width: 100%;
    min-width: 0;
  }
`;

export const ActionsBox = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-left: auto;

  @media (max-width: 1280px) {
    width: 100%;
    gap: 8px;
  }

  @media (max-width: 640px) {
    gap: 8px;
  }
`;

export const HeadBtnsBox = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const HeadBtnsLeft = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  min-width: 0;
  flex: 1;
`;

export const HeadBtnsRight = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-shrink: 0;
`;

export const StickyBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 1280px) {
    display: none;
  }
`;

export const MobileSaveProfileBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 24px;
  padding-bottom: max(24px, env(safe-area-inset-bottom));
  background: #fff;
  z-index: 1000;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 1281px) {
    display: none;
  }
`;

export const TabViewButtonsBox = styled.div`
  display: none;
  gap: 8px;
  align-items: center;

  @media (min-width: 1281px) {
    display: flex;
  }
`;

export const TabViewButton = styled(Button)<{ $isActive: boolean }>`
  && {
    width: 36px;
    height: 36px;
    min-width: 36px;
    padding: 8px;
    border-radius: 6px;
    border: ${({ $isActive }) =>
      $isActive ? '2px solid #E39A86' : `1px solid ${COLORS['neutral/300']}`} !important;
    background: ${({ $isActive }) => ($isActive ? COLORS['secondary/50'] : COLORS.white)};

    path {
      fill: none;
    }
  }
`;

export const MapTabButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  height: 36px;
  padding: 8px 12px;
  border: ${({ $isActive }) =>
    $isActive ? '2px solid #E39A86' : `1px solid ${COLORS['neutral/300']}`};
  border-radius: 6px;
  background: ${({ $isActive }) => ($isActive ? COLORS['secondary/50'] : COLORS.white)};
  cursor: pointer;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;

  &:hover {
    border-color: #e39a86;
  }
`;

export const MobileFilterBar = styled.div<{ $bannerOffset?: number }>`
  display: none;

  @media (max-width: 1280px) {
    display: flex;
    gap: 8px;
    align-items: center;
    position: fixed;
    top: ${({ $bannerOffset = 0 }) => 75 + $bannerOffset}px;
    left: 0;
    right: 0;
    z-index: 1099;
    background: ${COLORS.white};
    padding: 12px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  }
`;

/* height = padding-top(6) + content(36) + padding-bottom(6) = 48px */
export const MobileFilterBarSpacer = styled.div`
  display: none;

  @media (max-width: 1280px) {
    display: block;
    height: 44px;
  }
`;
